import { CustomerFSCaptionService } from '../setup/services/customer-fscaption.service';
import { CustomerFinancialStatementComponent } from './components/customer-financial-statement/customer-financial-statement.component';
import { EditGroupCustomerInfoComponent } from '../customer/components/customer/edit-group-customer-info/edit-group-customer-info.component';
import { LoanApplicationDetailsViewComponent } from '../credit/loans/loan-application-details-view/loan-application-details-view.component';
import { CustomerSearchComponent, CustomerInformationComponent, CustomerInformationDetailComponent, CustomerGroupComponent, KYCChecklistComponent } from '../customer/components';
import { CheckboxListValueAccessorDirective } from './directives/checkbox-list-value-accessor';
import { NgModule } from '@angular/core';
import { MessageComponent } from './common/app.message.component';
import { ConfirmDialogComponent } from './common/app.confirmdialog.component';
import { FormatMoneyDirective } from './directives/formatmoney.onblur.directive';
import { SanitzeHtmlUrlPipe } from './pipes/sanitize-url.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { CkeditorComponent } from './common/ckeditor.component';
import { PrintService } from './services/print.service';
import { DocumentUploadComponent } from './components/document-upload/document-upload.component';
import { DocumentpUloadService } from './services/document-upload.service';
import { OfferLetterComponent } from './components/offer-letter/offer-letter.component';
import { ApprovalActionsComponent } from './components/approval-actions/approval-actions.component';
import { WorkflowRoutingComponent } from './components/workflow-routing/workflow-routing.component';
import { ApprovalCommentsComponent } from './components/approval-comments/approval-comments.component';
import { SimpleCustomerSearchComponent } from './components/search/customer-search/customer-search.component';
import { BranchSearchComponent } from './components/branch-search/branch-search.component';

import { FacilitySummaryComponent } from './components/facility-summary/facility-summary.component';
import { CreditConditionComponent } from './components/credit-conditions/credit-condition.component';
import { TranxDynamicsComponent } from './components/transaction-dynamics/transaction-dynamics.component';

import { AdditionalCommentComponent } from './components/additional-comment/additional-comment.component';
import { LoanAccreditedConsultantsComponent } from './components/loan-accredited-consultants/loan-accredited-consultants.component';
import { CollateralRecommendationComponent } from './components/collateral-recommendation/collateral-recommendation.component';
import { MonitoringTriggerComponent } from './components/monitoring-triggers/monitoring-triggers.component';
import { RepaymentTermsComponent } from './components/repayment-terms/repayment-terms.component';
import { TwoFactorAuthComponent } from './components/two-factor-auth/two-factor-auth.component';
import { CasaAccountBalanceComponent } from './components/casa-account-balance/casa-account-balance.component';

import { DisbursedFacilityDetailComponent } from './components/disbursed-facility-detail/disbursed-facility-detail.component';
import { AuthorizationService } from '../admin/services';
import { CrmsRegulatoriesComponent } from './components/crms-regulatories/crms-regulatories.component';
import { CrmsService } from './services/crms.service';
import { DirectorRelatedCustomerComponent } from '../customer/components/customer/director-related-customer/director-related-customer.component';
import { IdleTimeoutService } from '../admin/services/idle-timeouter.service';
import { ScrollToTopComponent } from './common/scroll-to-top.component';
import { Form3800bLmsComponent } from './components/form-3800b-lms/form-3800b-lms.component';
import { Form3800bLosComponent } from './components/form-3800b-los/form-3800b-los.component';
import { TakeFeeSharedComponent } from './components/take-fee/take-fee-shared.component';
import { SheduleComponent } from 'app/credit/loans/schedule/schedule.component';
import { JobRequestComponent } from 'app/credit/job-request/job-request.component';
import { DepartmentService } from 'app/setup/services/department.service';
import { JobService } from 'app/credit/services/job.service';
import { RequestJobTypeService } from 'app/setup/services/request-job-type.service';
import { StaffRealTimeSearchService } from 'app/setup/services/staff-realtime-search.service';
import { CrmsRegulatoriesOperationsComponent } from './components/crms-regulatories/crms-regulatories-operations.component';
import { MappedLoanCollateralComponent } from './components/mapped-loan-collateral/mapped-loan-collateral.component';
import { AllContingentUsedComponent } from './components/all-contingent-used/all-contingent-used.component';
import { ContingentUsedDocumentComponent } from './components/contingent-used-document/contingent-used-document.component';
import { SuggestedConditionsComponent } from './components/suggested-conditions/suggested-conditions.component';
import { CreditRecommendedSuggestionsComponent } from './components/credit-recommendedsuggestions/credit-recommendedsuggestions.component';
import { DocumentUsageComponent } from './components/document-upload/document-usage.component';
import { RiskAcceptanceCriteriaComponent } from './components/risk-acceptance-criteria/risk-acceptance-criteria.component';
import { RiskAcceptanceCriteriaService } from './services/risk-acceptance-criteria.service';
import { CreditAppraisalService } from 'app/credit/services/credit-appraisal.service';
import { ApprovalCommentTabComponent } from './components/approval-comment-tab/approval-comment-tab.component';
import { RiskAcceptanceCriteriaDetailComponent } from './components/risk-acceptance-criteria-detail/risk-acceptance-criteria-detail.component';
import { WorkflowDecisionsComponent } from './workflow-decisions/workflow-decisions.component';
import { ReferBackComponent } from './components/refer-back/refer-back.component';
import { CollateralReleaseApprovalComponent, CollateralAssignmentApprovalComponent } from 'app/approvals/components';
import { LoanRecoveryRepaymentApprovalComponent } from 'app/credit/loan-management/loan-recovery-repayment-approval/loan-recovery-repayment-approval.component';
import { BulkDisbursementApprovalComponent } from 'app/approvals/components/credit-management/approvals/bulk-disbursement-approval.component';
import { AdhocApprovalComponent } from 'app/credit/adhoc-approval/adhoc-approval.component';
import { AtcReleaseApprovalComponent } from 'app/approvals/components/atc-release-approval/atc-release-approval.component';
import { ChecklistDeferralApprovalComponent } from 'app/approvals/components/credit-management/approvals/checklist-deferral-approval.component';
import { ContingentUsageAwaitingApprovalComponent } from 'app/approvals/components/loan-management/contingentLiability/awaiting-approval-contingent-usage-list.component';
import { ContingentUsageApprovalComponent } from 'app/approvals/components/loan-management/contingentLiability/awaiting-approval-contingent-usage.component';
import { CurrencyMaskDirective } from './directives/formatmoney.directive';
import { ReplyRequestComponent, JobRequestViewComponent, ExistingFacilitiesComponent, EndofdayComponent, ReviewApplicationListComponent, MaturityInstructionComponent, CPRolloverComponent, CPTenorExtensionComponent, CPInterestRateReviewComponent, CPRepaymentComponent, CPSubAllocationComponent, LoanApplicationCollateralInformationComponent, LoanApplicationsListComponent, ReasignRequestComponent, LoanEligibilityRequirementsComponent, CollateralMappingComponent, SecretariatComponent, LoanApplicationSearchComponent, CreditJobRequestComponent, LegalJobRequestConfirmation, FacilityJobRequestComponent, CreditAppraisalComponent, CovenantDetailComponent, BulkRateReviewComponent, LoanOperationsComponent, LoanRestructuringComponent, CustomerProductFeeComponent, CPPrepaymentComponent, LoanReviewApplicationComponent, LoanReviewAppraisalComponent, LoanReviewOfferLetterComponent, LoanReviewAvailmentComponent, RiskAssessmentComponent, CallMemoComponent, OverrideComponent, LoanAvailmentComponent, BondsAndGuaranteeComponent, InitiateLoanBookingComponent, LoanBookingComponent, ConvenantMaintenanceComponent, GuarantorMaintenanceComponent, OfferLetterGenerationComponent, OfferLetterGenererationReviewComponent, PreliminaryEvaluationComponent, ScheduleViewComponent, StartLoanApplicationComponent } from 'app/credit/components';
import { FacilityDetailsComponent, PreliminaryEvaluationViewComponent, LoanChecklistComponent, RejectedApplicationComponent, CreditDocumentUploadComponent, CollateralCreationComponent, CreditBureauSearchComponent, ProductFeeConcessionComponent } from 'app/credit/loans';
import { LoanApplicationCovenantComponent } from 'app/credit/shared/covenant/loan-application-covenant.component';
import { ExistingCamsolComponent } from 'app/credit/shared/existing-camsol/existing-camsol.component';
import { CollateralInformationViewComponent, CollateralSwapComponent, CollateralInformationComponent, CollateralAssignmentComponent, CollateralReleaseComponent, LienOnInvestmentComponent } from 'app/credit/collateral';
import { CustomFieldTestComponent, FinancialStatementComponent, ChecklistItemComponent } from 'app/setup/components';
import { ConditionChecklistComponent } from 'app/credit/loans/loan-checklist/condition-checklist.component';
import { LimitExposureComponent } from 'app/credit/loans/application/limits/limit-exposure.component';
import { FirstTraderComponent } from 'app/credit/loans/application/facility-details/extentions/first-trader.component';
import { EducationLoanComponent } from 'app/credit/loans/application/facility-details/extentions/education-loan.component';
import { BondGurantyComponent } from 'app/credit/loans/application/facility-details/extentions/bond-guranty.component';
import { DisbursedLoanDetailsComponent } from 'app/credit/loan-management/disbursed-loan-details/disbursed-loan-details.component';
import { UnDisbursedLoanDetailsComponent } from 'app/credit/loan-management/disbursed-loan-details/undisbursed-loan-details.component';
import { ContingentUsageComponent } from 'app/credit/loans/contingent-usage/contingent-usage.component';
import { LoanReviewOperationsComponent } from 'app/credit/loan-management/loan-operations/loan-review-operation.component';
import { ReassignAccountComponent } from 'app/credit/loan-management/reassignaccount/reassignaccount.component';
import { ProductFeesComponent } from 'app/credit/loans/application/facility-details/productfees.component';
import { ChildSectorLimitComponent } from 'app/credit/loans/application/limits/sector-limit.component';
import { DisbursedCommercialLoanDetailsComponent } from 'app/credit/loan-management/disbursed-loan-details/disbursed-cp-and-fx-loan-details.component';
import { LoanDisbursement2Component } from 'app/credit/loans/loan-disbursement/loan-disbursement2.component';
import { UISharedModule } from './ui-shared-module';
import { PsrCkeditorComponent } from 'app/credit/project-site-report/psr-ckeditor/psr-ckeditor.component';
import { CollateralValuationComponent } from 'app/credit/collateral/collateral-valuation/collateral-valuation.component';
import { ExpiredFacilityReportComponent } from 'app/reports/expired-facility-report/expired-facility-report.component';
import { CustomSearchComponent } from './components/search/customer-search/custom-search.component';
import { EsgChecklistScoreComponent } from 'app/setup/components/checklist/esg-checklist-score.component';
import { AlertSetupComponent } from 'app/setup/components/alert-setup/alert-setup.component';
import { OperationRouteComponent } from 'app/credit/routes/operation-route.component';
import { DeferredLoanFeeComponent } from 'app/credit/loans/booking/deferred-loan-fee/deferred-loan-fee.component';
import { TakeFeeComponent } from 'app/credit/loan-management/take-fee/take-fee.component';
import { RemedialOpreationComponent } from 'app/credit/loan-management/remedial-opreation/remedial-opreation.component';
import { LoanWorkflowReportComponent } from 'app/reports/loan-workflow/loan-workflow-sla/loan-workflow-sla.report.component';
import { EmployerTypeComponent } from 'app/setup/components/employer-type/employer-type.component';
import { ProfileSetupComponent } from 'app/setup/components/profile-setting/profilesetting.component';
import { CollateralInformationReleaseComponent } from 'app/credit/collateral/information/collateral-information-release.component';
import { CollateralReleaseAwaitingJobRequestComponent } from 'app/credit/collateral/information/collateral-release-awaiting-job-request.component';
import { CollateralReleaseListComponent } from 'app/credit/collateral/information/collateral-release-list.component';
import { LoanFeeAdjustmentComponent } from 'app/credit/loan-management/loan-fee-adjustment/loan-fee-adjustment.component';
import { LoanPerformanceComponent } from 'app/credit/loan-management/loan-performance/loan-performance.component';
import { FXRevolvingLoanReviewOperationsComponent } from 'app/credit/loan-management/fx-revolving-loan-operations/fx-revolving-loan-operation.component';
import { LoanRecoveryPaymentPlanComponent } from 'app/credit/loan-management/loanrecovery-paymentplan/loanrecoverypaymentplan.component';
import { LoanRecoveryPaymentComponent } from 'app/credit/loan-management/loan-recovery-payment/loan-recovery-payment.component';
import { FXRevolvingLoanPaymentComponent } from 'app/credit/loan-management/fx-loan-payment/fx-revolving-loan-payment.component';
import { LoanCamsolComponent } from 'app/credit/loan-management/loan-camsol/loan-camsol.component';
import { LoanApplicationDetailsComponent } from 'app/credit/loans/application/loan-application-details.component';
import { CrmsRegulatoryComponent } from 'app/credit/loans/crms-regulatory/crms-regulatory.component';
import { LMSCrmsRegulatoryComponent } from 'app/credit/loans/crms-regulatory/lms-crms-regulatory.component';
import { ChecklistItemSimulationComponent } from 'app/credit/loans/checklist-item-simulation/checklist-item-simulation.component';
import { FacilityDetailSummaryComponent } from 'app/credit/loans/facility-detail-summary/facility-detail-summary.component';
import { SlaMonitoringComponent } from 'app/credit/sla/sla-monitoring.component';
import { AvailmentRouteComponent } from 'app/credit/routes/availment-route.component';
import { LoanFeeConcessionComponent } from 'app/credit/loans/loan-fee-concession/loan-fee-concession.component';
import { DefferalManagementComponent } from 'app/credit/loans/defferal-management/defferal-management.component';
import { LoanCrmsUpdateComponent } from 'app/credit/loans/booking/loan-crms-update.component';
import { ContingentFacilityReleaseComponent } from 'app/credit/loans/booking/contingent-release.component';
import { ContingentUsageListComponent } from 'app/credit/loans/contingent-usage/contingent-usage-list.component';
import { MapComponent } from 'app/credit/map/map.component';
import { TrancheFacilityUtilizationComponent } from 'app/credit/loans/facility-details/tranche-facility-utilization.component';
import { CompletedLoanConfirmationComponent } from 'app/credit/loans/completed-loan-confirmation/completed-loan-confirmation.component';
import { LoanDisburstmentReportComponent } from 'app/reports/loan-reports/loan-disburstment/loan-disburstment.report.component';
import { RunningFacilitiesComponent } from 'app/reports/loan-reports/running-facilities/running-facilities.component';
import { MiddleOfficeReportComponent } from 'app/reports/loan-reports/middle-office-report/middle-office-report.component';
import { InActiveContigentLiabilityReportComponent } from 'app/reports/loan-reports/in-active-contigent-liability-report/in-active-contigent-liability-report.component';
import { CreditScheduleReportComponent } from 'app/reports/loan-reports/credit-schedule-report/credit-schedule-report.component';
import { BulkDisbursementComponent } from 'app/admin/components/bulk-disbursement/bulk-disbursement.component';
import { LcConditionComponent } from 'app/credit/letter-of-credit/lc-condition/lc-condition.component';
import { LcDocumentsComponent } from 'app/credit/letter-of-credit/lc-documents/lc-documents.component';
import { LcShippingComponent } from 'app/credit/letter-of-credit/lc-shipping/lc-shipping.component';
import { StartLetterOfCreditComponent } from 'app/credit/letter-of-credit/start-letter-of-credit/start-letter-of-credit.component';
import { CancelContingentLiabilityComponent } from 'app/credit/loan-management/cancel-contingent-liability/cancel-contingent-liability.component';
import { CommercialLoanReviewOperationsComponent } from 'app/credit/loan-management/commercial-loan-operations/commercial-loan-operations.component';
import { ContingentLiabilityTreminateRebookComponent } from 'app/credit/loan-management/contingent-liability-terminate-rebook/contingent-liability-terminate-rebook.component';
import { ContingentOpreationComponent } from 'app/credit/loan-management/contingent-operations/contingent-operations.component';
import { ContingentTerminationComponent } from 'app/credit/loan-management/contingent-termination/contingent-termination.component';
import { FacilityLineReviewOperationsComponent } from 'app/credit/loan-management/facility-line-operations/line-operation.component';
import { FullAndFinalStatusChangeComponent } from 'app/credit/loan-management/full-and-final-status-change/full-and-final-status-change.component';
import { GlobalInterestRateChangeComponent } from 'app/credit/loan-management/global-interest-rate-change/global-interest-rate-change.component';
import { LoanPrepaymentComponent } from 'app/credit/loan-management/loan-prepayment/loanprepayment.component';
import { LoanReviewApplicationSearchComponent } from 'app/credit/loan-management/loan-review-application-search/loan-review-application-search.component';
import { LoanTerminationComponent } from 'app/credit/loan-management/loan-termination/loantermination.component';
import { OverdraftOperationsComponent } from 'app/credit/loan-management/overdraft-operations/overdraft-operations.component';
import { ReportCollateralValuationComponent } from 'app/reports/loan-reports/collateral-valuation/collateral-valuation.component';
import { LcIssuanceComponent } from 'app/credit/letter-of-credit/lc-issuance/lc-issuance.component';
import { LcIssuanceApprovalComponent } from 'app/credit/letter-of-credit/lc-issuance-approval/lc-issuance-approval.component';
import { CkeditiorProjectComponent } from './common/ckeditior-project.component';
import { StaffReliefComponent } from 'app/setup/components/staff-relief/staff-relief.component';
import { ContigentLiabilityReportComponent } from 'app/reports/contigent-liability-report/contigent-liability-report.component';
import { RiskAssetContigentReportMainComponent } from 'app/reports/risk-asset-contigent-report-main/risk-asset-contigent-report-main.component';
import { CbnNplTeamReportComponent } from 'app/reports/cbn-npl-team-report/cbn-npl-team-report.component';
import { RiskAssetByCbnNplClassificationReportComponent } from 'app/reports/risk-asset-by-cbn-npl-classification-report/risk-asset-by-cbn-npl-classification-report.component';
import { RiskAssetMain1Component } from 'app/reports/risk-asset-main-1/risk-asset-main-1.component';
import { ModifyFacilityComponent } from 'app/credit/modify-facility/modify-facility.component';
import { CollateralsProposedComponent } from 'app/credit/collateral/collaterals-proposed/collaterals-proposed.component';
import { CollateralSwapApprovalComponent } from 'app/approvals/components/loan-management/approvals/collateral-swap/collateral-swap-approval.component';
import { RiskAssetCalcCombinedReportTeamComponent } from 'app/reports/risk-asset-calc-combined-report-team/risk-asset-calc-combined-report-team.component';
import { ApprovalMonitoringComponent } from 'app/reports/approval-monitoring/approval-monitoring.component';
import { RiskAssetCalcCombinedReportComponent } from 'app/reports/risk-asset-calc-combined-report/risk-asset-calc-combined-report.component';
import { ContingentLiabilityReportMain1ReportComponent } from 'app/reports/contingent-liability-report-main-1-report/contingent-liability-report-main-1-report.component';
import { RiskAssetCombinedReportComponent } from 'app/reports/risk-asset-combined-report/risk-asset-combined-report.component';
import { CopyOfRiskAssetByIfrsClassificationComponent } from 'app/reports/copy-of-risk-asset-by-ifrs-classification/copy-of-risk-asset-by-ifrs-classification.component';
import { ContigentLiabilityReportMainReportComponent } from 'app/reports/contigent-liability-report-main-report/contigent-liability-report-main-report.component';
import { CopyOfRiskAssetMainReportComponent } from 'app/reports/copy-of-risk-asset-main-report/copy-of-risk-asset-main-report.component';
import { HintComponent } from './hint/hint.component';
import { ExternalUrlComponent } from 'app/admin/components/external-url/external-url.component';
import { ModifyFacilityDetailsComponent } from 'app/credit/modify-facility/modify-facility-details/modify-facility-details.component';
import { ExceptionalLoanApprovalComponent } from 'app/credit/exceptional-loan-approval/exceptional-loan-approval.component';
import { ReassignRequestComponent } from './components/reassign-request/reassign-request.component';
import { LoanReviewDrawdownComponent } from 'app/credit/loan-management/loan-operations/loan-review-drawdown.component';
import { DrawdownComponent } from 'app/credit/loans/booking/drawdown.component';
import { NumberDirective } from './directives/numbers-only.directive';
import { NumberAndDecimalDirective } from './directives/numbers-decimal-only.directive';

// import { AppMenuComponent, AppSubMenuComponent } from './common/app.menu.component';



@NgModule({
    imports: [
        UISharedModule
    ],

    exports: [
        RiskAcceptanceCriteriaDetailComponent,
        HintComponent,
         PsrCkeditorComponent,
        UISharedModule,
        CreditRecommendedSuggestionsComponent,
        SuggestedConditionsComponent,
        MessageComponent,
        CheckboxListValueAccessorDirective,
        ConfirmDialogComponent,
        CustomerSearchComponent,
        FormatMoneyDirective,
        SanitzeHtmlUrlPipe,
        TimeAgoPipe,
        CkeditorComponent,
        CkeditiorProjectComponent,
        CustomerInformationComponent,
        CustomerInformationDetailComponent,
        LoanApplicationDetailsViewComponent,
        EditGroupCustomerInfoComponent,
        DocumentUploadComponent,
        ApprovalActionsComponent,
        ApprovalCommentsComponent,
        WorkflowRoutingComponent,
        CustomerFinancialStatementComponent,
        OfferLetterComponent,
        SimpleCustomerSearchComponent,
        BranchSearchComponent, FacilitySummaryComponent,
        CreditConditionComponent, TranxDynamicsComponent,
        CollateralRecommendationComponent, 
        AdditionalCommentComponent, 
        LoanAccreditedConsultantsComponent,
        MonitoringTriggerComponent,
        RepaymentTermsComponent,
        TwoFactorAuthComponent,
        CasaAccountBalanceComponent,
        DisbursedFacilityDetailComponent,
        CrmsRegulatoriesComponent,CrmsRegulatoriesOperationsComponent,
        DirectorRelatedCustomerComponent,
        ScrollToTopComponent,
        Form3800bLmsComponent,
        Form3800bLosComponent,
        TakeFeeSharedComponent,
        SheduleComponent,
        JobRequestComponent,
        MappedLoanCollateralComponent,
        AllContingentUsedComponent,
        ContingentUsedDocumentComponent,
        RiskAcceptanceCriteriaComponent,
        DocumentUsageComponent, ApprovalCommentTabComponent,
        ReferBackComponent,
      
        

        
        CurrencyMaskDirective,
        NumberDirective,
        NumberAndDecimalDirective,
        ReplyRequestComponent, 
        FacilityDetailsComponent,
        PreliminaryEvaluationViewComponent, 
        JobRequestViewComponent, 
        LoanApplicationCovenantComponent, 
        ExistingFacilitiesComponent,
        ExistingCamsolComponent,
        LoanChecklistComponent, 
        LoanChecklistComponent,
        RejectedApplicationComponent, 
        CollateralInformationViewComponent, 
        CreditDocumentUploadComponent,
        CollateralCreationComponent, 
        CollateralSwapComponent, EndofdayComponent,
        CreditDocumentUploadComponent, 
        CollateralInformationComponent, 
        CreditBureauSearchComponent,

        ConditionChecklistComponent,
        ProductFeeConcessionComponent,
        ReviewApplicationListComponent,
        LimitExposureComponent,
         FirstTraderComponent,
        EducationLoanComponent, 
        BondGurantyComponent,
        DisbursedLoanDetailsComponent, 
        UnDisbursedLoanDetailsComponent,
        ContingentUsageComponent,
        LoanReviewOperationsComponent,
        ReassignAccountComponent,
        ProductFeesComponent,
        MaturityInstructionComponent,  
        CPRolloverComponent,
        CPTenorExtensionComponent,
         CPInterestRateReviewComponent,
        CPRepaymentComponent, 
        CPSubAllocationComponent,  
        ChildSectorLimitComponent, 
        DisbursedCommercialLoanDetailsComponent, 
        LoanDisbursement2Component,
        CollateralValuationComponent,
        ExpiredFacilityReportComponent,
        CustomSearchComponent,
        EsgChecklistScoreComponent,
        AlertSetupComponent,
        OperationRouteComponent,
        DeferredLoanFeeComponent,
        TakeFeeComponent,
        RemedialOpreationComponent,
        

        KYCChecklistComponent,
        LoanApplicationCollateralInformationComponent,
        LoanApplicationsListComponent,
        ReasignRequestComponent,
        FinancialStatementComponent,
        LoanWorkflowReportComponent,
        ChecklistItemComponent,
        EmployerTypeComponent,
        ChecklistItemComponent,
        EmployerTypeComponent,
        ProfileSetupComponent,
        LoanEligibilityRequirementsComponent,
        CollateralMappingComponent,
        SecretariatComponent,
        LoanApplicationSearchComponent,
        CreditJobRequestComponent,
        LegalJobRequestConfirmation,
        FacilityJobRequestComponent,
        CollateralAssignmentComponent,
        CollateralReleaseComponent,
        CreditAppraisalComponent,
        CovenantDetailComponent,
        BulkRateReviewComponent,
        LoanOperationsComponent,
        LoanRestructuringComponent,
        CustomerProductFeeComponent,
        CPPrepaymentComponent,
        LoanReviewApplicationComponent,
        LoanReviewAppraisalComponent,
        LoanReviewOfferLetterComponent,
        LoanReviewAvailmentComponent,
        RiskAssessmentComponent,
        CallMemoComponent,
        OverrideComponent,
        LoanAvailmentComponent,
        BondsAndGuaranteeComponent,
        InitiateLoanBookingComponent,
        LoanBookingComponent,
        ConvenantMaintenanceComponent,
        GuarantorMaintenanceComponent,
        OfferLetterGenerationComponent,
        OfferLetterGenererationReviewComponent,
        PreliminaryEvaluationComponent,
        ScheduleViewComponent,
        StartLoanApplicationComponent,
        CollateralInformationReleaseComponent,
        CollateralReleaseAwaitingJobRequestComponent,
        CollateralReleaseListComponent,
        LoanFeeAdjustmentComponent,
        LoanPerformanceComponent,
        FXRevolvingLoanReviewOperationsComponent,
        LoanRecoveryPaymentPlanComponent,
        LoanRecoveryPaymentComponent,
        FXRevolvingLoanPaymentComponent,
        LoanCamsolComponent,
        LoanApplicationDetailsComponent,
        CrmsRegulatoryComponent,
        LMSCrmsRegulatoryComponent,
        ChecklistItemSimulationComponent,
        FacilityDetailSummaryComponent,
        AvailmentRouteComponent,
        LoanFeeConcessionComponent,
        DefferalManagementComponent,
        LoanCrmsUpdateComponent,
        ContingentFacilityReleaseComponent,
        ContingentUsageListComponent,
        MapComponent,
        TrancheFacilityUtilizationComponent,
        CompletedLoanConfirmationComponent,
        LoanDisburstmentReportComponent,
        RunningFacilitiesComponent,
        MiddleOfficeReportComponent,
        CollateralValuationComponent,
        InActiveContigentLiabilityReportComponent,
        CreditScheduleReportComponent,
        BulkDisbursementComponent,
        LcConditionComponent,
        LcDocumentsComponent,
        LcShippingComponent,
        StartLetterOfCreditComponent,
        CancelContingentLiabilityComponent,
        CommercialLoanReviewOperationsComponent,
        ContingentLiabilityTreminateRebookComponent,
        ContingentOpreationComponent,
        ContingentTerminationComponent,
        FacilityLineReviewOperationsComponent,
        FullAndFinalStatusChangeComponent,
        GlobalInterestRateChangeComponent,
        LoanPrepaymentComponent,
        LoanReviewApplicationSearchComponent,
        LoanTerminationComponent,
        OverdraftOperationsComponent,
       
        CollateralReleaseApprovalComponent,
        CollateralAssignmentApprovalComponent,
        SlaMonitoringComponent,
        ReportCollateralValuationComponent,
        CustomFieldTestComponent,
        LcIssuanceComponent,
        LcIssuanceApprovalComponent,

        LienOnInvestmentComponent,
        StaffReliefComponent,
        ContigentLiabilityReportComponent,
        RiskAssetContigentReportMainComponent,
        CbnNplTeamReportComponent ,
        RiskAssetByCbnNplClassificationReportComponent,
        RiskAssetMain1Component,
        ModifyFacilityComponent,
        ModifyFacilityDetailsComponent,
        CollateralsProposedComponent,
        CollateralSwapApprovalComponent,
        RiskAssetCalcCombinedReportTeamComponent,
        ApprovalMonitoringComponent,
        RiskAssetCalcCombinedReportComponent,
        ContingentLiabilityReportMain1ReportComponent,
        ContigentLiabilityReportMainReportComponent,
        CopyOfRiskAssetByIfrsClassificationComponent,
        RiskAssetCombinedReportComponent,
        CopyOfRiskAssetMainReportComponent,
        ReassignRequestComponent,
        LoanReviewDrawdownComponent,
        DrawdownComponent


    ],

    declarations: [
        RiskAcceptanceCriteriaDetailComponent,
        ExternalUrlComponent,
        HintComponent,
        CreditRecommendedSuggestionsComponent,
        SuggestedConditionsComponent,
        MessageComponent,
        CheckboxListValueAccessorDirective,
        ConfirmDialogComponent,
        CustomerSearchComponent,
        CustomerGroupComponent,
        FormatMoneyDirective,
        SanitzeHtmlUrlPipe,
        TimeAgoPipe,
        CkeditorComponent,
        CustomerInformationComponent,
        CustomerInformationDetailComponent,
        LoanApplicationDetailsViewComponent,
        EditGroupCustomerInfoComponent,
        DocumentUploadComponent,
        ApprovalActionsComponent,
        WorkflowRoutingComponent,
        ApprovalCommentsComponent,
        CustomerFinancialStatementComponent,
        OfferLetterComponent,
        SimpleCustomerSearchComponent,
        BranchSearchComponent,
        CreditConditionComponent, TranxDynamicsComponent,
        CollateralRecommendationComponent, FacilitySummaryComponent,
        MonitoringTriggerComponent, AdditionalCommentComponent, 
        LoanAccreditedConsultantsComponent,
        RepaymentTermsComponent,
        TwoFactorAuthComponent,
        CasaAccountBalanceComponent,
        DisbursedFacilityDetailComponent,
        CrmsRegulatoriesComponent,CrmsRegulatoriesOperationsComponent,
        DirectorRelatedCustomerComponent,
        ScrollToTopComponent,
        Form3800bLmsComponent,
        Form3800bLosComponent,
        TakeFeeSharedComponent,
        SheduleComponent,
        JobRequestComponent,
        MappedLoanCollateralComponent,
        AllContingentUsedComponent,
        ContingentUsedDocumentComponent,
        RiskAcceptanceCriteriaComponent,
        DocumentUsageComponent,
        ApprovalCommentTabComponent,
      
        WorkflowDecisionsComponent,
        ReferBackComponent,
        LoanRecoveryRepaymentApprovalComponent,
         BulkDisbursementApprovalComponent,
        AdhocApprovalComponent,AtcReleaseApprovalComponent,
        ChecklistDeferralApprovalComponent,
        ContingentUsageAwaitingApprovalComponent,
        ContingentUsageApprovalComponent,
        CkeditiorProjectComponent,
        ExceptionalLoanApprovalComponent,
        // AppMenuComponent,
        // AppSubMenuComponent


        CurrencyMaskDirective,
        NumberDirective,
        NumberAndDecimalDirective,
        ReplyRequestComponent, 
        FacilityDetailsComponent,
        PreliminaryEvaluationViewComponent, 
        JobRequestViewComponent, 
        LoanApplicationCovenantComponent, 
        ExistingFacilitiesComponent,
        ExistingCamsolComponent,
        LoanChecklistComponent, 
        LoanChecklistComponent,
        RejectedApplicationComponent, 
        CollateralInformationViewComponent, 
        CreditDocumentUploadComponent,
        CollateralCreationComponent, 
        CollateralSwapComponent, EndofdayComponent,
        CreditDocumentUploadComponent, 
        CollateralInformationComponent, 
        CreditBureauSearchComponent,
 
        ConditionChecklistComponent,
        ProductFeeConcessionComponent,
        ReviewApplicationListComponent,
        LimitExposureComponent,
         FirstTraderComponent,
        EducationLoanComponent, 
        BondGurantyComponent,
        DisbursedLoanDetailsComponent, 
        UnDisbursedLoanDetailsComponent,
        ContingentUsageComponent,
        LoanReviewOperationsComponent,
        ReassignAccountComponent,
        ProductFeesComponent,
        MaturityInstructionComponent,  
        CPRolloverComponent,
        CPTenorExtensionComponent,
         CPInterestRateReviewComponent,
        CPRepaymentComponent, 
        CPSubAllocationComponent,  
        ChildSectorLimitComponent, 
        DisbursedCommercialLoanDetailsComponent, 
        LoanDisbursement2Component,
        PsrCkeditorComponent,
        CollateralValuationComponent,
        ExpiredFacilityReportComponent,
        CustomSearchComponent,
        EsgChecklistScoreComponent,
        AlertSetupComponent,
        OperationRouteComponent ,
        DeferredLoanFeeComponent,
        TakeFeeComponent,
        RemedialOpreationComponent,

        KYCChecklistComponent,
        LoanApplicationCollateralInformationComponent,
        LoanApplicationsListComponent,
        ReasignRequestComponent,
        FinancialStatementComponent,
        LoanWorkflowReportComponent,
        ChecklistItemComponent,
        EmployerTypeComponent,
        ChecklistItemComponent,
        EmployerTypeComponent,
        ProfileSetupComponent,
        LoanEligibilityRequirementsComponent,
        CollateralMappingComponent,
        SecretariatComponent,
        LoanApplicationSearchComponent,
        CreditJobRequestComponent,
        LegalJobRequestConfirmation,
        FacilityJobRequestComponent,
        CollateralAssignmentComponent,
        CollateralReleaseComponent,
        CreditAppraisalComponent,
        CovenantDetailComponent,
        BulkRateReviewComponent,
        LoanOperationsComponent,
        LoanRestructuringComponent,
        CustomerProductFeeComponent,
        CPPrepaymentComponent,
        LoanReviewApplicationComponent,
        LoanReviewAppraisalComponent,
        LoanReviewOfferLetterComponent,
        LoanReviewAvailmentComponent,
        RiskAssessmentComponent,
        CallMemoComponent,
        OverrideComponent,
        LoanAvailmentComponent,
        BondsAndGuaranteeComponent,
        InitiateLoanBookingComponent,
        LoanBookingComponent,
        ConvenantMaintenanceComponent,
        GuarantorMaintenanceComponent,
        OfferLetterGenerationComponent,
        OfferLetterGenererationReviewComponent,
        PreliminaryEvaluationComponent,
        ScheduleViewComponent,
        StartLoanApplicationComponent,
        CollateralInformationReleaseComponent,
        CollateralReleaseAwaitingJobRequestComponent,
        CollateralReleaseListComponent,
        LoanFeeAdjustmentComponent,
        LoanPerformanceComponent,
        FXRevolvingLoanReviewOperationsComponent,
        LoanRecoveryPaymentPlanComponent,
        LoanRecoveryPaymentComponent,
        FXRevolvingLoanPaymentComponent,
        LoanCamsolComponent,
        LoanApplicationDetailsComponent,
        CrmsRegulatoryComponent,
        LMSCrmsRegulatoryComponent,
        ChecklistItemSimulationComponent,
        FacilityDetailSummaryComponent,
        SlaMonitoringComponent,
        AvailmentRouteComponent,
        LoanFeeConcessionComponent,
        DefferalManagementComponent,
        LoanCrmsUpdateComponent,
        ContingentFacilityReleaseComponent,
        ContingentUsageListComponent,
        MapComponent,
        TrancheFacilityUtilizationComponent,
        CompletedLoanConfirmationComponent,
        LoanDisburstmentReportComponent,
        RunningFacilitiesComponent,
        MiddleOfficeReportComponent,
        CollateralValuationComponent,
        InActiveContigentLiabilityReportComponent,
        CreditScheduleReportComponent,
        BulkDisbursementComponent,
        LcConditionComponent,
        LcDocumentsComponent,
        LcShippingComponent,
        StartLetterOfCreditComponent,
        CancelContingentLiabilityComponent,
        CommercialLoanReviewOperationsComponent,
        ContingentLiabilityTreminateRebookComponent,
        ContingentOpreationComponent,
        ContingentTerminationComponent,
        FacilityLineReviewOperationsComponent,
        FullAndFinalStatusChangeComponent,
        GlobalInterestRateChangeComponent,
        LoanPrepaymentComponent,
        LoanReviewApplicationSearchComponent,
        LoanTerminationComponent,
        OverdraftOperationsComponent,
   

        CollateralReleaseApprovalComponent,
        CollateralAssignmentApprovalComponent,
        CollateralValuationComponent,
        CustomFieldTestComponent,
        ReportCollateralValuationComponent,
        LcIssuanceComponent,
        LcIssuanceApprovalComponent,
        LienOnInvestmentComponent,
        StaffReliefComponent,
        ContigentLiabilityReportComponent,
        RiskAssetContigentReportMainComponent,
        CbnNplTeamReportComponent ,
        RiskAssetByCbnNplClassificationReportComponent,
        RiskAssetMain1Component,
        ModifyFacilityComponent,
        ModifyFacilityDetailsComponent,
        CollateralsProposedComponent,
        CollateralSwapApprovalComponent,
        RiskAssetCalcCombinedReportTeamComponent,
        ApprovalMonitoringComponent,
        RiskAssetCalcCombinedReportComponent,
        ContingentLiabilityReportMain1ReportComponent,

        ContigentLiabilityReportMainReportComponent,
        CopyOfRiskAssetByIfrsClassificationComponent,
        RiskAssetCombinedReportComponent,
        CopyOfRiskAssetMainReportComponent,
        ReassignRequestComponent,
        LoanReviewDrawdownComponent,
        DrawdownComponent

        

  
    ],

    providers: [
        PrintService,
        DocumentpUloadService,
        CustomerFSCaptionService,
        AuthorizationService, CrmsService,
        IdleTimeoutService,
        DepartmentService,
        JobService,
        RequestJobTypeService,
        StaffRealTimeSearchService,
        RiskAcceptanceCriteriaService,
        CreditAppraisalService
        
    ],
})
export class BankingSharedModule { }